// Import all styles
import '../styles/main.scss'
// Try alpine
import 'alpinejs/dist/alpine'
